import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CommitmentType } from 'further-types/lp/vehicle';
import { useLayoutContext } from 'contexts/LayoutContext';

const transactionTypeOptions = [
  {
    value: CapitalActionEntryType.Expense,
    label: 'Expense',
  },
  {
    value: CapitalActionEntryType.Investment,
    label: 'Investment',
  },
  {
    value: CapitalActionEntryType.Fees,
    label: 'Fees',
  },
  {
    value: CapitalActionEntryType.GeneralCapitalCall,
    label: 'Capital Call - General capital',
  },
  {
    value: CapitalActionEntryType.AdvanceSubscriptionPayment,
    label: 'Capital Call - Advance subscription payment',
  },
  {
    value: CapitalActionEntryType.CapitalContributionCall,
    label: 'Capital Call - Capital contribution call',
  },
  {
    value: CapitalActionEntryType.CapitalRefund,
    label: 'Return of capital',
  },
  {
    value: CapitalActionEntryType.CapitalDistribution,
    label: 'Distribution',
  },
  {
    value: CapitalActionEntryType.Equalisation,
    label: 'Equalisation',
  },
];

export default function useAvailableTransactionTypeOptions({
  currentEntryType,
  currentEntryIndex,
  entriesCount,
  hasDistributionEntry,
  hasUncalledEqualisations,
}: {
  currentEntryType: CapitalActionEntryType;
  currentEntryIndex: number;
  entriesCount: number;
  hasDistributionEntry: boolean;
  hasUncalledEqualisations: boolean;
}) {
  const { vehicle } = useLayoutContext();
  const isCapitalAndLoan =
    vehicle?.commitmentType === CommitmentType.CapitalAndLoan;
  const hasUncalledCapitalContribution =
    vehicle?.hasUncalledCapitalContribution ?? false;
  const isLastEntry = currentEntryIndex === entriesCount - 1;

  const isFirstEntry = currentEntryIndex === 0;
  if (
    isFirstEntry &&
    vehicle &&
    hasUncalledCapitalContribution &&
    isCapitalAndLoan
  ) {
    return transactionTypeOptions.filter(
      (option) =>
        option.value === CapitalActionEntryType.CapitalContributionCall,
    );
  }

  if (isFirstEntry && hasUncalledEqualisations) {
    return transactionTypeOptions.filter(
      (option) => option.value === CapitalActionEntryType.Equalisation,
    );
  }

  return transactionTypeOptions
    .filter(
      (option) =>
        (currentEntryType === CapitalActionEntryType.CapitalDistribution ||
          option.value !== CapitalActionEntryType.CapitalDistribution ||
          (isLastEntry && !hasDistributionEntry)) &&
        (option.value !== CapitalActionEntryType.CapitalContributionCall ||
          isCapitalAndLoan),
    )
    .map((option) => ({
      ...option,
      disabled:
        (option.value === CapitalActionEntryType.CapitalDistribution &&
          (!vehicle?.carrySettings.carriedInterestFeeTemplates.length ||
            !vehicle?.firstCloseDate)) ||
        (option.value === CapitalActionEntryType.CapitalContributionCall &&
          (!hasUncalledCapitalContribution || !isFirstEntry)),
    }));
}
